const searchClass: string = "js-talk-search";
const searchContentClass: string = "js-talk-search-content";
const searchActiveClass: string = "c-talk__search--active";

//検索ボタン押下　検索窓の表示
document.addEventListener("click", (event: any) => {
  const searchButton: HTMLElement = event.target.closest(`.${searchClass}`)!;
  if (searchButton) {
    const searchContent: HTMLElement = document.querySelector(`.${searchContentClass}`)!;
    searchContent.classList.toggle(searchActiveClass);
  }
});


const searchInputClass: string = "js-talk-search-input" //検索入力エリア
const searchFormClass: string = "js-talk-search-form"; //検索入力フォーム
const searchResultClass: string = "c-talk__search__result";
const searchResultActive: string = "c-talk__search__result--active";
//検索開始
document.addEventListener("submit", async(event: any) => {
  const searchForm: HTMLElement = event.target.closest(`.${searchFormClass}`)!;
  if (searchForm) {
    const searchInput: HTMLInputElement = document.querySelector(`.${searchInputClass}`)!;
    const searchValue: string = searchInput.value;
    const searchResult: HTMLElement = document.querySelector(`.${searchResultClass}`)!;
    if (searchValue.length == 0) {
      searchResult.classList.remove(searchResultActive);
      await SearchWordReset();
    } else {
      searchResult.classList.add(searchResultActive);
      await SearchWordReset();
      await SearchWord(searchValue);
      ResultNumSet(searchValue);
    }
    event.preventDefault();
  }
});


const messageClass: string = "c-talk__message"; 
const highlightClass: string = "c-talk__message--highlight";
const highlightActiveClass: string = "c-talk__message--highlight--active";
//検索結果、数値の入力
const resultCurrentClass: string = "js-search-result-current";
const resultAllClass: string = "js-search-result-all";
const ResultNumSet = (searchValue: string) => {
  const current: HTMLElement = document.querySelector(`.${resultCurrentClass}`)!;
  const all: HTMLElement = document.querySelector(`.${resultAllClass}`)!;
  const messageLists: NodeListOf<HTMLElement> = document.querySelectorAll(`.${messageClass}`);
  let matchNum:number = 0;
  //文字列検索ループ
  for(let i = 0; messageLists.length > i; i++) {
    let hit = messageLists[i].innerHTML.match(new RegExp(searchValue, 'g'));
    if (hit) {
      matchNum += hit.length;
    }
  }
  if (matchNum) {
    current.innerText = "1";
    all.innerText = String(matchNum);
    SelectHighlight(1);
  } else {
    current.innerText = "0";
    all.innerText = "0";
  }
}

const chatBoxClass: string = "p-talk__chat"; 
//ハイライトセレクト
const SelectHighlight = (goNum: number) => {
  goNum -= 1;
  const highlights: NodeListOf<HTMLElement> = document.querySelectorAll(`.${highlightClass}`);
  if (highlights) {
    highlights[goNum].classList.add(highlightActiveClass);
    const messageBox: HTMLElement = highlights[goNum].closest(".c-talk__message")!;
    const chatBox: HTMLElement = document.querySelector(`.${chatBoxClass}`)!;
    const chatBoxTop: number = chatBox.offsetTop;
    const targetTop: number = messageBox.offsetTop - chatBoxTop;
    const padding: number = 100;
    chatBox.scroll({
      top: targetTop - padding,
      left: 0,
      behavior: 'smooth'
    });
  }
}

//次へ
document.addEventListener("click", (event: any) => {
  const next = event.target.closest(".js-result-down");
  const prev = event.target.closest(".js-result-up");
  if (next || prev) {
    SearchNextPrev(next, prev)
  }
})

const SearchNextPrev = (next: HTMLElement, prev: HTMLElement) => {
  const active: HTMLElement = document.querySelector(`.${highlightActiveClass}`)!;
  const resultCurrent:HTMLElement = document.querySelector(`.${resultCurrentClass}`)!;
  const resultAll:HTMLElement = document.querySelector(`.${resultAllClass}`)!;
  const resultCurrentNum:number = Number(resultCurrent.innerText);
  const resultAllNum:number = Number(resultAll.innerText);
  if (next && resultAllNum !== resultCurrentNum) {
    active.classList.remove(highlightActiveClass);
    resultCurrent.innerText = String(resultCurrentNum + 1);
    SelectHighlight(resultCurrentNum + 1);
  } else if (prev && 1 < resultCurrentNum) {
    active.classList.remove(highlightActiveClass);
    resultCurrent.innerText = String(resultCurrentNum - 1);
    SelectHighlight(resultCurrentNum - 1);
  } else {
    false
  }
}


//検索ハイライトのリセット
const SearchWordReset = ():Promise<boolean> => {
  return new Promise((resolve) => {
    const messageLists: NodeListOf<HTMLElement> = document.querySelectorAll(`.${messageClass}`);
    for(let i = 0; messageLists.length > i; i ++) {
      const text = messageLists[i].innerHTML;
      let newText = text.replace(/c-talk__message--highlight/g, "");
      newText = newText.replace(/c-talk__message--highlight--active/g, "");
      newText = newText.replace(/<span class="">/g, "");
      newText = newText.replace(/<\/span>/g, "");
      messageLists[i].innerHTML = newText;
    }
    resolve(true);
  })
}

//検索
const SearchWord = async (searchValue: string):Promise<boolean> => {
  return new Promise((resolve) => {
    const messageLists: NodeListOf<HTMLElement> = document.querySelectorAll(`.${messageClass}`);
    for(let i = 0; messageLists.length > i; i ++) {
      const text = messageLists[i].innerHTML; //メッセージテキスト
      const newText = text.replace(new RegExp(searchValue, 'g'), `<span class="c-talk__message--highlight">${searchValue}</span>`);
      messageLists[i].innerHTML = newText;
    }
    resolve(true);
  })
}
